import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { CheckCircleIcon } from 'lucide-react';
export function FinalCTA() {
  const steps = ['Complete the enrollment form', 'Watch the briefing', 'If selected, you will be contacted'];
  return <section className="py-32 px-6 bg-[var(--forge-charcoal)] relative overflow-hidden" data-id="element-10">
      {/* Dramatic background effect */}
      <div className="absolute inset-0" data-id="element-11">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[var(--forge-lava)] to-transparent" data-id="element-12" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[var(--forge-lava)] to-transparent" data-id="element-13" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-[var(--forge-lava)] opacity-10 blur-[150px] rounded-full" data-id="element-14" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-16">
          <h2 className="text-5xl md:text-7xl font-black tracking-tighter mb-6 leading-tight" data-id="element-17">
            READY TO STEP INTO{' '}
            <span className="text-[var(--forge-lava)]" data-id="element-18">THE FORGE</span>?
          </h2>

          <p className="text-xl text-[var(--forge-gray)] mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-19">
            We do not accept everyone. Only those willing to rise are invited to
            enter.
          </p>

          <div className="bg-[var(--forge-steel)] border border-[var(--forge-zinc)]/30 p-8 mb-12 max-w-2xl mx-auto" data-id="element-20">
            <h3 className="text-2xl font-black mb-6 text-left" data-id="element-21">THE PROCESS:</h3>
            <div className="space-y-4" data-id="element-22">
              {steps.map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="flex items-start gap-4 text-left" data-id="element-23">
                  <CheckCircleIcon className="w-6 h-6 text-[var(--forge-lava)] flex-shrink-0 mt-1" data-id="element-24" />
                  <span className="text-lg text-[var(--forge-white)]" data-id="element-25">
                    {step}
                  </span>
                </motion.div>)}
            </div>
          </div>

          <Link to="/apply" data-id="element-26">
            <Button size="lg" className="text-xl px-16 py-5" data-id="element-27">
              APPLY TO THE FORGE
            </Button>
          </Link>

          <p className="text-sm text-[var(--forge-gray)] mt-6 italic" data-id="element-28">
            This is a commitment. Not a click.
          </p>
        </motion.div>
      </div>
    </section>;
}